module.exports = __webpack_public_path__ + "static/GastonA-76880593214b27afc74f59006fed86f6.gif";